export function initAccordion(root) {
    if (!root || root.__accordionInit) return;
    root.__accordionInit = true;

    const multiple = (root.dataset.multiple || "false") === "true";

    root.addEventListener(
        "toggle",
        (e) => {
            const details = e.target;

            if (!(details instanceof HTMLDetailsElement)) return;

            const summary = details.querySelector("summary");
            if (summary) {
                summary.setAttribute("aria-expanded", details.open ? "true" : "false");
            }

            if (multiple) return;
            if (!details.open) return;

            root.querySelectorAll("details[open]").forEach((other) => {
                if (other !== details) {
                    other.open = false;

                    const otherSummary = other.querySelector("summary");
                    if (otherSummary) {
                        otherSummary.setAttribute("aria-expanded", "false");
                    }
                }
            });

            if (summary && typeof summary.focus === "function") {
                summary.focus();
            }
        },
        true
    );
}